import { ContractTaskDto, UpdateTaskRequest, useUpdateContractTaskMutation } from "../../../../../autogen/bff-api";
import { useCreateEditor, useEntityState } from "../../../../../common/editing/save-coordinator";

export const contractTaskEditorId = (taskId: string) => `contract-task:${taskId}`;

export const useContractTaskEditor = (loaded: ContractTaskDto): ContractTaskDto => {
  const [update] = useUpdateContractTaskMutation();
  const editorId = contractTaskEditorId(loaded.id);
  useCreateEditor<ContractTaskDto, UpdateTaskRequest>(editorId, {
    initialState: loaded,
    save: (fields) => update({ taskId: loaded.id, updateTaskRequest: fields as UpdateTaskRequest }).unwrap(),
  });
  return useEntityState<ContractTaskDto>(editorId) ?? loaded;
};
